import aesReduxConstants from '../constants';

const soundActions = function() {
  const factory = {};
  const constants = aesReduxConstants;

  factory.playSound = function(media, loop, finished) {
    if (loop === undefined || loop === null) loop = false;

    return {
      type: constants.PLAY_SOUND,
      meta: {
        sound: {
          media,
          loop,
          finished,
        },
      },
    };
  };

  // caught by the sound middleware and just pauses all of the audios in sound store
  factory.stopAllSounds = function() {
    return {
      type: constants.STOP_ALL_SOUNDS,
    };
  };

  return factory;
};

export default soundActions();
